@let tolOptions = tol();
<div class="d-f col h-100 w-100-p">
  <div>
    @if (skizze(); as base64) {
      <span>{{ 'Skizze' | mrTranslate }}</span>
      <br />
      <app-image-slide-show [data]="[{ base64, name: name() }]" invert height="25vh" />
    }
  </div>
  <clr-datagrid [clrDgItemsIdentityFn]="row => row?.ID" class="datagrid-compact sticky-action-column h-auto">
    <clr-dg-column class="mw-0">{{ 'Vgl.' | mrTranslate }}</clr-dg-column>
    @for (column of messungen().columns; track column.id) {
      <clr-dg-column>
        <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['ztyp', 'position', 'track'] }">
          {{ column.id | transformColNames: tolOptions | mrTranslate }}
        </ng-container>
      </clr-dg-column>
    }
    <clr-dg-row *clrDgItems="let row of messungen().rows" [clrDgItem]="row" [class.headerRow]="row.isHeader">
      <clr-dg-cell class="mw-0">
        <a href="javascript:void(0)" (click)="selectedRow.set(row)">
          <cds-icon shape="line-chart" size="20" />
        </a>
      </clr-dg-cell>
      @for (cell of messungen().columns; track cell.id) {
        @if (cell.id.startsWith('Tol-Verl. - ') || cell.id == 'Ausfall') {
          <clr-dg-cell class="noover">
            @if (row[cell.id]; as ausfall) {
              <span class="label ausfall" [style.--ausfall-color]="ausfall.toString() | getAusfallColor: tolOptions">
                {{ ausfall }}
              </span>
            }
          </clr-dg-cell>
        } @else {
          @if(cell.id == ersterEintragMessung() && row['Ist-Neu'] !== null){
            <clr-dg-cell class="name-cell grid-icon success-green">            
              <div class="cell-content">
                <span>{{ row[cell.id] | tablePrettyPrint }}</span>
                <clr-tooltip>
                  <clr-icon clrTooltipTrigger shape="info-circle" size="24"></clr-icon>
                  <clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'lg'" class="multiline-tooltip">
                    {{ 'Instandsetzung' | mrTranslate }}: {{ row['Instand_Datum'] | tablePrettyPrint }}
                    <br>
                    <br>
                    {{ 'Instandsetzer' | mrTranslate }}: {{ row['Instandsetzer'] | tablePrettyPrint }}
                    <br>
                    <br>
                    {{ 'orginal Ist' | mrTranslate }}: {{ row['Ist'] | tablePrettyPrint }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </div>
            </clr-dg-cell>
          }
          @else {
          <clr-dg-cell class="name-cell" [class.sticky-action]="cell.id == 'Bezeichnung'">
            {{ row[cell.id] | tablePrettyPrint }}
          </clr-dg-cell>
          }
        }
      }
    </clr-dg-row>

    <clr-dg-footer>{{ messungen().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
  </clr-datagrid>
</div>

<app-messung-vergleich [(row)]="selectedRow" [tol]="tolOptions" />
